module.exports = __webpack_public_path__ + "static/img/reference pics_cgu university1.f3cf8be8.jpg";